import React, { useContext, useEffect, useState } from "react";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";
import AutoComplete from "../../../Shared/AutosuggestV2/Autosuggestv2";
import { toast } from "react-toastify";
import axios from "../../../../Axios";
import { Urls } from "../../../../Urls";

import {
  Activity,
  currentRequestTimeStamp,
  DateFormatter2,
} from "../../../../Constants";

import { checkModuleAccess } from "../../../../Utility";

const NewPlacementDetails = ({
  getEnquiryApis,
  newSpot,
  enquiryBucket,
  item = "",
  editmode = false,
  planningbutton,
  backbutton,
  discovernowbutton,
  onClose,
}) => {
  if (newSpot === true) editmode = true


  const [show, setshow] = useState(false);


  const [shortlistedLsp, setShortListedLsp] = useState([]);
  const fieldMap = {
    location_code: "Location Code",
    addressLine1: "Address",
    location_name: "Location Name",
    gst_no: "GST No",
    customer_name: "Customer Name",
    pincode: "Pincode",
  };
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);

  const [drop, setDrop] = useState(item?.lane_details?.drop || "oneway");
  const [multiDropDetails, setMultiDropDetails] = useState([]);
  const [companyProfile, setCompanyProfile] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const { TrackMixPanel } = useMixPanelForTracking(
    userDetails,
    companySettingData
  );
  const [additionalDetails, setAdditionalDetails] = useState(
    item?.additional_details || item?.lane_details?.additional_details || ""
  );
  const [origin, setOrigin] = useState(item?.lane_details?.origin || {});
  const [destination, setDestination] = useState(item?.lane_details?.destination || {});
  const [originCodeLocked, setOriginCodeLocked] = useState(false);
  const [destinationCodeLocked, setDestinationCodeLocked] = useState(false);

  // poc email for spot created by agent
  const pocEmail = companySettingData && companySettingData?.agent_settings?.spot_agent?.agent_poc?.length > 0 && companySettingData?.agent_settings?.spot_agent?.agent_poc[0]?.email || localStorage?.getItem("useremail")


  const userEmail = userDetails?.email;

  const hasEmail = !!item?.email;

  const isOwner = hasEmail && item.email === userEmail;

  const isAgentSpot =
    item?.email?.startsWith("lorri.agent") &&
    userEmail === pocEmail;

  const restrictUser = hasEmail && !isOwner && !isAgentSpot;



  useEffect(() => {
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - placement details",
      Data: `lane: ${item.lane_details?.origin.location_name} to ${item.lane_details?.destination.location_name}, truck type : ${item?.lane_details?.truck_types?.[0]?.label}`,
      Definition: `user viewed placement details for an enquiry`,
    });
    if (item) {
      setDrop(item?.lane_details?.drop || "oneway");
      setAdditionalDetails(item?.additional_details || item?.lane_details?.additional_details || "");
      setOrigin(item?.lane_details?.origin || {});
      setDestination(item?.lane_details?.destination || {});
      setOriginCodeLocked(!!item?.lane_details?.origin?.location_name);
      setDestinationCodeLocked(!!item?.lane_details?.destination?.location_name);

      // add 1 multidrop initially.
      setMultiDropDetails(
        Array.isArray(item?.lane_details?.drop_locations) && item.lane_details?.drop_locations.length > 0
          ? item.lane_details.drop_locations.map((row) => ({
            ...row,
            codeLocked: !!row?.drop_location?.location_name,
          }))
          : [{
            id: 1,
            codeLocked: false,
            drop_location: {
              addressLine1: "",
              location_name: "",
              location_code: "",
              gst_no: "",
              customer_name: "",
              pincode: ""
            }
          }]);
    }
    if (item.savecompanyprofile) {
      setCompanyProfile(true);
    }
  }, [item]);

  // load lsps list.
  useEffect(() => {
    if (item?.lane_details?.drop === "point to point") {
      setDrop("oneway")
    }
    if ((!newSpot && !planningbutton && !discovernowbutton && !backbutton) && editmode) {
      const fetchLsps = async () => {
        try {
          const res = await axios.get(
            `${Urls.spot}?field=get_enquiry&truck_enquiry_id=${item.truck_enquiry_id}`
          );

          const enquiryData = res.data.enquiry_lane_details ? res.data.enquiry_lane_details[0] : res.data;
          const lane = res.data.enquiry_lane_details ? res.data.enquiry_lane_details[0] : res.data;
          const bench = lane?.benchmark_transporter_list;

          if (
            bench &&
            bench.length > 0
          ) {
            setShortListedLsp(
              bench
            );
          } else {
            setShortListedLsp([]);
          }
        } catch (error) {
          console.log(error);
        }
      };
      fetchLsps();
    } else {
      setShortListedLsp([]);
    }
  }, [editmode, item]);

  const addNewMultidrop = () => {
    setMultiDropDetails((prev) => [
      ...prev,
      { id: prev.length + 1, codeLocked: false, drop_location: {} },
    ]);
  };

  const removeNewMultidrop = () => {
    setMultiDropDetails((prev) => (prev.length > 0 ? prev.slice(0, -1) : prev));
  };

  const handleFieldChange = (index, field, value) => {
    setMultiDropDetails((prev) =>
      prev.map((row, i) =>
        i === index
          ? { ...row, drop_location: { ...row.drop_location, [field]: value } }
          : row
      )
    );
  };

  const handleOriginChange = (field, val) => {
    setIsEdited(true);
    setOrigin((prev) => ({ ...prev, [field]: val }));
  };

  const handleDestinationChange = (field, val) => {
    setIsEdited(true);
    setDestination((prev) => ({ ...prev, [field]: val }));
  };

  // const handleLocationChange = (selectedLocation, index) => {
  //   const {
  //     location_name,
  //     addressLine1,
  //     pincode,
  //     location_code,
  //     customer_name,
  //     gst_no,
  //   } = selectedLocation;

  //   setMultiDropDetails((prev) =>
  //     prev.map((row, i) =>
  //       i === index
  //         ? {
  //           ...row,
  //           drop_location: {
  //             ...row.drop_location,
  //             location_name,
  //             addressLine1:
  //               !addressLine1 || addressLine1.trim() === ""
  //                 ? row.drop_location?.addressLine1 || ""
  //                 : addressLine1,
  //             pincode,
  //             location_code,
  //             customer_name,
  //             gst_no,
  //           },
  //         }
  //         : row
  //     )
  //   );
  // };

  const handleLocationChange = (selectedLocation, index) => {

    setMultiDropDetails((prev) =>
      prev.map((row, i) => {

        if (i !== index) return row

        // 🔥 IF → CLEAR (❌ clicked)
        if (!selectedLocation) {
          return {
            ...row,
            drop_location: {
              ...row.drop_location,
              location_name: "",
              addressLine1: "",
              pincode: "",
              location_code: "",
              customer_name: "",
              gst_no: "",
            },
          }
        }

        // 🔥 ELSE → LOCATION SELECTED
        const {
          location_name = "",
          addressLine1 = "",
          pincode = "",
          location_code = "",
          customer_name = "",
          gst_no = "",
        } = selectedLocation

        return {
          ...row,
          drop_location: {
            ...row.drop_location,

            location_name,

            addressLine1:
              addressLine1 && addressLine1.trim() !== ""
                ? addressLine1
                : row.drop_location?.addressLine1 || "",

            pincode,
            location_code,
            customer_name,
            gst_no,
          },
        }
      })
    )
  }

  const hanldeSubmit = () => {
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - placement details",
      Data: `lane: ${item && item.lane_details?.origin && item.lane_details?.origin.location_name
        ? item.lane_details?.origin.location_name
        : ""
        } to ${item && item.lane_details?.destination && item.lane_details?.destination.location_name
          ? item.lane_details?.destination.location_name
          : ""
        }, truck type : ${item?.lane_details?.truck_types?.[0]?.label}, drop: ${drop}`,
      Definition: `user submitted placement details for an enquiry`,
    });
    // validation for origin -> location name
    if (
      !origin ||
      !origin?.addressLine1 ||
      origin?.addressLine1.trim() === ""
    ) {
      toast.error("Please Enter Origin Address");
      return;
    }

    // validation for destination -> location name
    if (
      !destination ||
      !destination?.addressLine1 ||
      destination?.addressLine1.trim() === ""
    ) {
      toast.error("Please Enter Destination Address");
      return;
    }

    // validation for destination -> location name
    if (
      drop === "multidrop" &&
      multiDropDetails &&
      multiDropDetails?.length > 0
    ) {
      const addressLocations = multiDropDetails?.some(
        (md) =>
          !md?.drop_location?.addressLine1 ||
          !md?.drop_location?.addressLine1?.trim() === ""
      );
      if (addressLocations) {
        toast.error("Please enter Address for all the Multidrop locations");
        return;
      }
    }

    if (multiDropDetails?.length > 0 && item.lane_details) {
      item.lane_details.drop_locations = multiDropDetails;
    }
    if (item) {
      item.additional_details = additionalDetails;
      if (item.lane_details) {
        item.lane_details.drop = drop;
        item.lane_details.origin = origin;
        item.lane_details.destination = destination;
        item.lane_details.additional_details = additionalDetails;
      }
    }
    toast.success("Placement details submitted successfully");
    if (onClose) onClose();
  };

  const handleUpdate = async () => {
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - placement details",
      Data: `lane: ${item && item.lane_details?.origin && item.lane_details?.origin.location_name
        ? item.lane_details?.origin.location_name
        : ""
        } to ${item && item.lane_details?.destination && item.lane_details?.destination.location_name
          ? item.lane_details?.destination.location_name
          : ""
        }, truck type : ${item?.lane_details?.truck_types?.[0]?.label}, drop: ${drop}`,
      Definition: `user edited placement details for an enquiry`,
    });

    if (
      !origin ||
      !origin?.addressLine1 ||
      origin?.addressLine1.trim() === ""
    ) {
      toast.error("Please Enter Origin Address");
      return;
    }

    // validation for destination -> location name
    if (
      !destination ||
      !destination?.addressLine1 ||
      destination?.addressLine1.trim() === ""
    ) {
      toast.error("Please Enter Destination Address");
      return;
    }

    // validation for destination -> location name
    if (
      drop === "multidrop" &&
      multiDropDetails &&
      multiDropDetails?.length > 0
    ) {
      const addressLocations = multiDropDetails?.some(
        (md) =>
          !md?.drop_location?.addressLine1 ||
          !md?.drop_location?.addressLine1?.trim() === ""
      );
      if (addressLocations) {
        toast.error("Please enter Address for all the Multidrop locations");
        return;
      }
    }
    try {
      const uri = `${Urls.spot}?field=edit_enquiry_v2`;
      let payload = {
        truck_enquiry_id: item?.truck_enquiry_id,
        drop: drop,
        drop_locations: (drop === "multidrop" ? multiDropDetails : []) || [],
        additional_details: additionalDetails,
        lane_details: {
          additional_details: additionalDetails,
        }
      };

      if (!newSpot && isEdited) {
        payload = {
          ...payload,
          origin: origin,
          destination: destination,
        };
      }

      await axios.post(uri, payload);

      if (item) {
        item.additional_details = additionalDetails;
        if (item.lane_details) {
          item.lane_details.additional_details = additionalDetails;
        }
      }

      toast.success("Placement Details Updated.");
      getEnquiryApis();
      setIsEdited(false);
      if (onClose) onClose();
    } catch (error) {
      console.log("Err while saving placement details", error);
    }
  };

  if (!editmode || restrictUser) {
    return (
      <div>
        <div className="card border-0 shadow-sm">
          <div className="card-body p-3">
            {/* Trip Type Badge */}
            <div className="mb-2">
              <span className="badge badge-pill badge-secondary">
                {drop === "roundtrip"
                  ? "↔ Round Trip"
                  : drop === "multidrop"
                    ? "Multi Drop"
                    : "→ One Way"}
              </span>
            </div>

            {/* Route Flow */}
            <div className="bg-light rounded p-3 mb-3">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <small className="text-muted">Loading Address</small>
                  <div className="font-weight-bold">
                    {origin?.location?.label || origin?.location_name || "NA"}
                  </div>
                  <div className="text-muted small">
                    {origin?.addressLine1 || ""}
                  </div>
                </div>

                <div className="text-center px-3" style={{ fontSize: "22px" }}>
                  {drop === "roundtrip" ? "↔" : "→"}
                </div>

                <div className="text-right">
                  <small className="text-muted">
                    <span>{drop === "multidrop" && "Final "}</span>Unloading
                    Address
                  </small>
                  <div className="font-weight-bold">
                    {destination?.location?.label ||
                      destination?.location_name ||
                      "NA"}
                  </div>
                  <div className="text-muted small">
                    {destination?.addressLine1 || ""}
                  </div>
                </div>
              </div>
            </div>

            {/* Multi Drop Locations */}
            {drop === "multidrop" && multiDropDetails?.length > 0 && (
              <div className="mb-3">
                <div className="font-weight-bold mb-1">Unloading Addresses</div>
                {multiDropDetails.map((md) => (
                  <div
                    key={md?.id}
                    className="border rounded p-2 mb-1 bg-white"
                    style={{ fontSize: "13px" }}
                  >
                    <b>{md?.id}.</b>{" "}
                    {md?.drop_location?.location?.label ||
                      md?.drop_location?.location_name ||
                      "NA"}
                    {md?.drop_location?.addressLine1 &&
                      ` - ${md.drop_location.addressLine1}`}
                  </div>
                ))}
              </div>
            )}

            {/* Additional Details */}
            <div className="border-top pt-2">
              <small className="text-muted d-block">Additional Details</small>
              <div className="font-italic">{additionalDetails || "NA"}</div>
            </div>
          </div>
          <div className="p-3">
            <small className="text-muted d-block">Product Types</small>
            <div>
              {(() => {
                const productTypes =
                  item?.lane_details?.product_types ||
                  item?.product_types ||
                  item?.lane_details?.product_type ||
                  item?.product_type ||
                  [];
                return productTypes && productTypes.length > 0 ? (
                  productTypes.map((pt, i) => (
                    <span key={i} className="badge badge-primary mr-2 mb-1">
                      {pt?.value || pt?.label || pt}
                    </span>
                  ))
                ) : (
                  <span className="text-muted font-italic">NA</span>
                );
              })()}
            </div>
          </div>
        </div>
        {restrictUser && <div className="text-info mt-4 ml-1">Only the user with the email address {item?.email?.startsWith("lorri.agent") ? pocEmail : item?.email} can edit these details.</div>}
      </div>
    );
  }

  return (
    <div className="p-2">
      {editmode && (
        <div
          className="alert alert-warning py-1 px-2 mb-2"
          style={{ fontSize: "13px" }}
        >
          <b>Note:</b> Data will be added only after clicking Submit.
        </div>
      )}

      {editmode && (
        <div className="d-flex align-items-center mb-2 justify-content-between">
          <div className="d-flex align-items-start flex-column">
            <div
              className="d-flex align-items-center my-2 flex-wrap"
              style={{ gap: "6px" }}
            >
              {["oneway", "roundtrip", "multidrop"].map((type) => (
                <button
                  key={type}
                  type="button"
                  className="btn btn-default btn-sm"
                  style={{
                    background: drop === type ? "#e0e0e0" : "#fff",
                    color: drop === type ? "#54af3a" : "#393185",
                    // border: "1px solid #ddd",
                    minWidth: "90px",
                  }}
                  onClick={() => {
                    setDrop(type);
                    if (type !== "multidrop") {
                      setMultiDropDetails([]);
                    }
                  }}
                >
                  {type === "oneway"
                    ? "One-way"
                    : type === "roundtrip"
                      ? "Round-Trip"
                      : "Multi-Drop"}
                </button>
              ))}
            </div>

            <div
              className="text-muted"
              style={{ fontSize: "13px", marginTop: "4px" }}
            >
              <b>Note:</b> Loading & Unloading addresses are mandatory.
            </div>
          </div>

          {/* <div className="d-flex align-items-center" style={{ gap: "5px" }}>
            <input
              type="checkbox"
              checked={companyProfile}
              onChange={(e) => setCompanyProfile(e.target.checked)}
              style={{ width: "15px", height: "15px" }}
            />
            <span className="mt-2" style={{ fontSize: "13px" }}>
              Save in company profile
            </span>
          </div> */}
        </div>
      )}

      <div
        style={{ maxHeight: "50vh", overflowX: "hidden", overflowY: "auto" }}
      >
        {/* Loading Address */}
        <div className="rounded p-2 mb-2">
          <div className="font-weight-bold mb-1" style={{ fontSize: "13px" }}>
            Loading Address
          </div>

          <div className="row">
            {[
              "location_code",
              "addressLine1",
              "location_name",
              "gst_no",
              "customer_name",
              "pincode",
            ].map((field, i) => (
              <div className="col-md-2 mb-1" key={i}>
                <small
                  className="text-muted d-block mb-1"
                  style={{ fontSize: "12px" }}
                >
                  {fieldMap[field]} {fieldMap[field] === "Address" && <span className="text-danger">*</span>}
                </small>
                <input
                  // placeholder={fieldMap[field]}
                  value={origin[field] || ""}
                  onChange={(e) => handleOriginChange(field, e.target.value)}
                  disabled={field === "location_name" || (field === "location_code" && originCodeLocked)}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Multidrop Section */}
        {editmode && drop === "multidrop" && (
          <div className="border rounded p-2 mb-2">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div className="font-weight-bold" style={{ fontSize: "13px" }}>
                Unloading Addresses
              </div>

              <div>
                <button
                  className="btn btn-primary btn-sm mr-1"
                  onClick={addNewMultidrop}
                >
                  <i className="fa fa-plus" />
                </button>

                <button
                  className="btn btn-danger btn-sm"
                  disabled={multiDropDetails?.length <= 1}
                  onClick={removeNewMultidrop}
                >
                  <i className="fa fa-minus" />
                </button>
              </div>
            </div>

            {/* Multi-drop list */}
            {multiDropDetails?.length > 0 &&
              multiDropDetails.map((md, index) => (
                <div className="row mb-1" key={index}>
                  {[
                    "location_code",
                    "addressLine1",
                    "location_name",
                    "gst_no",
                    "customer_name",
                    "pincode",
                  ].map((field, i) => (
                    <div className="col-md-2 mb-1" key={i}>
                      <small
                        className="text-muted d-block mb-1"
                        style={{ fontSize: "12px" }}
                      >
                        {fieldMap[field]} {fieldMap[field] === "Address" && <span className="text-danger">*</span>}
                      </small>
                      {field === "location_name" ? (
                        <AutoComplete
                          key={`loc_${i}_${index}`}
                          value={
                            md.drop_location?.location_name
                              ? {
                                value: md.drop_location.location_name,
                                label: md.drop_location.location_name,
                              }
                              : ""
                          }
                          placeholder="Location"
                          module_key="indents"
                          user_identifier={userDetails?.profile_company_id}
                          onChange={(val) =>
                            handleFieldChange(index, field, val)   // string
                          }
                          onSelect={(obj) =>
                            handleLocationChange(obj, index)       // full object
                          }
                        />
                      ) : (
                        <input
                          value={md.drop_location[field] || ""}
                          onChange={(e) =>
                            handleFieldChange(index, field, e.target.value)
                          }
                          disabled={field === "location_code" && md.codeLocked}
                        />
                      )}
                    </div>
                  ))}
                </div>
              ))}
          </div>
        )}

        {/* Destination / Unloading Address */}
        {editmode && (
          <div className="rounded p-2 mb-2">
            <div className="font-weight-bold mb-1" style={{ fontSize: "13px" }}>
              {drop === "multidrop"
                ? "Destination Address"
                : "Unloading Address"}
            </div>

            <div className="row">
              {[
                "location_code",
                "addressLine1",
                "location_name",
                "gst_no",
                "customer_name",
                "pincode",
              ].map((field, i) => (
                <div className="col-md-2 mb-1" key={i}>
                  <small
                    className="text-muted d-block mb-1"
                    style={{ fontSize: "12px" }}
                  >
                    {fieldMap[field]} {fieldMap[field] === "Address" && <span className="text-danger">*</span>}
                  </small>
                  <input
                    // placeholder={fieldMap[field]}
                    value={destination[field] || ""}
                    onChange={(e) =>
                      handleDestinationChange(field, e.target.value)
                    }
                    disabled={field === "location_name" || (field === "location_code" && destinationCodeLocked)}
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {editmode ? (
          <div className="rounded p-2">
            <div className="font-weight-bold mb-1" style={{ fontSize: "13px" }}>
              Additional Message
            </div>
            <textarea
              value={additionalDetails}
              onChange={(e) => setAdditionalDetails(e.target.value)}
              rows={2}
              style={{
                resize: "vertical",
                minHeight: "50px",
                maxHeight: "90px",
                fontSize: "13px",
              }}
            />
          </div>
        ) : (
          <div>
            <b>Additional Details:</b> {additionalDetails}
          </div>
        )}
      </div>

      {editmode && <div className="text-center mt-2">
        {newSpot || planningbutton || discovernowbutton || backbutton ? (
          <button
            onClick={hanldeSubmit}
            className="btn btn-success btn-sm px-3"
          >
            Submit
          </button>
        ) : (
          <button onClick={handleUpdate} className="btn btn-info btn-sm px-3">
            Update
          </button>
        )}
      </div>}
    </div>
  );
};

export default NewPlacementDetails;

